import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import { AppRoutes } from './router';
import { initGA, logPageView } from './utils/analytics';

function App() {
  useEffect(() => {
    initGA();
    logPageView();
  }, []);

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL || '/'}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;